import { DailyInsightQuery, InsightEntity, InsightPage, InsightPageQuery } from '@/graphql/generated/graphql';
import { QUERY_CURRENT_DAILY_INSIGHT, QUERY_DAILY_INSIGHT_PAGE } from '@/graphql/queries/daily/daily-insight';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<InsightPageQuery>({
      query: QUERY_DAILY_INSIGHT_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.insightPage?.data?.attributes as InsightPage,
    error,
  };
};

export const getDailyInsight = async () => {
  const now = new Date();
  const date = now.toISOString().split('T')[0];
  const data = await requestDailyInsight(date);

  if (!data?.insights?.data.length) {
    return null;
  }

  return {
    insight: data?.insights?.data[0] as InsightEntity,
  };
};

const requestDailyInsight = async (date?: string) => {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<DailyInsightQuery>({
      query: QUERY_CURRENT_DAILY_INSIGHT,
      variables: {
        date: {
          eq: date,
        },
      },
      fetchPolicy: 'network-only',
    }),
  );

  return data;
};
